// extracted by mini-css-extract-plugin
export default {"container":"Equip_container__sBd4z","linkAsics":"Equip_linkAsics__mWTHU"};